import { configureAndGetDefaultOrm } from "./ConfigureOrm";
import { createReducer } from "redux-orm";
import { combineReducers, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga';
import rootSaga from "./ConfigureSagas";
import { composeWithDevTools } from 'redux-devtools-extension';




export const configureOrmWithEntities = () => {    
    const ormModel = configureAndGetDefaultOrm();
    const sagaMiddleware = createSagaMiddleware()
    const rootReducer = combineReducers({ orm3: createReducer(ormModel)});
    const composeEnhancers = composeWithDevTools({});
    const store = createStore(rootReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
    sagaMiddleware.run(rootSaga)
    return store;
}


// WEBPACK FOOTER //
// ./src/Config/ConfigureEntities.ts